export function getEmailIntegrationLabel(emailIntegration) {
    const emailAddress = emailIntegration.spf_sender_email || emailIntegration.email_address || '';
    return emailIntegration.sender_name
        ? `${emailIntegration.sender_name} <${emailAddress}>`
        : emailAddress;
}
